import {
  Box,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import {
  formatRecordKeys,
  recordToChartData,
  recordToLabeledArray,
} from "../../utils/common";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { ChartData, DmmsBarChart } from "../charts/DmmsBarChart";
import { grey, red } from "@mui/material/colors";
import DmmsPieChart from "../charts/DmmsPieChart";
import { RefreshButton } from "../Button/RefreshButton";

import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import TableRowsIcon from "@mui/icons-material/TableRows";


import { useState } from "react";
interface CounterMetricControllerProps {
  data: Record<string, number>;
  loading: boolean;
  controller?: JSX.Element;
  refresh: () => void;
  reset: () => void;
  title: string;
  verticalLayout?: boolean;
}

export const CountMetricsChart = ({
  data,
  loading,
  controller,
  refresh,
  reset,
  title,
  verticalLayout = false,
}: CounterMetricControllerProps) => {
  const useData = formatRecordKeys(data) as Record<string, number>;
  const barData: ChartData = recordToChartData(useData);
  const pieData = recordToLabeledArray(useData);

  const [isVertical, setIsVertical] = useState(verticalLayout);

  const layoutStyles = getLayoutStyles(isVertical);

  const toggleLayoutChange = () => {
    setIsVertical(!isVertical);
  };
  const chartHeight= isVertical ? 500 :300
  return (
    <Stack spacing={1} width={"100%"} sx={styles.layout}>
      <Typography sx={styles.title}>{title}</Typography>

      <Box>{controller}</Box>
      <Stack
        width={"100%"}
        direction={"row"}
        justifyContent={"flex-end"}
        pt={2}
      >
        <Stack direction={"row"} alignItems={"center"}></Stack>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Tooltip
            title={
              isVertical
                ? "change to horizontal layout"
                : "change to veritcal layout"
            }
          >
            <IconButton
              sx={layoutStyles.layoutBtn}
              onClick={toggleLayoutChange}
            >
              {isVertical ?  <ViewCarouselIcon />: <TableRowsIcon />}
            </IconButton>
          </Tooltip>

          <Tooltip title={"Reset"}>
            <IconButton
              sx={{
                borderRadius: 2,
                backgroundColor: red[50],
              }}
              onClick={reset}
            >
              <RotateLeftIcon fontSize="small" sx={{ color: red[400] }} />
            </IconButton>
          </Tooltip>

          <RefreshButton onclick={refresh} loading={loading} />
        </Stack>
      </Stack>

      <Box>
        {isVertical ? (
          // vertical stacked layout
          <Stack spacing={2}>
            <Box height={chartHeight} sx={layoutStyles.barContainer}>
              <DmmsBarChart data={barData} loading={loading} height={chartHeight}/>
            </Box>
            <Box height={chartHeight} sx={layoutStyles.pieContainer}>
              <DmmsPieChart height={chartHeight} loading={loading} data={pieData} title="" />
            </Box>
          </Stack>
        ) : (
          // horizontal grid layout
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={2} sm={6} md={6}>
              <Box height={chartHeight} sx={layoutStyles.barContainer}>
                <DmmsBarChart data={barData} loading={loading} height={chartHeight} />
              </Box>
            </Grid>
            <Grid item xs={2} sm={6} md={6}>
              <Box height={chartHeight} sx={layoutStyles.pieContainer}>
                <DmmsPieChart height={chartHeight}  loading={loading} data={pieData} title="" />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
    </Stack>
  );
};

const getLayoutStyles = (isVertical: boolean) => ({
  layoutBtn: {
    borderRadius: 1,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: grey[200],
    backgroundColor: grey[100],
    p: 0,
    width: 35,
    height: 35,
  },
  barContainer: {
    backgroundColor: grey[200],
    borderRadius: 2,
  },
  pieContainer: {
    backgroundColor: grey[200],
    borderRadius: 2,
  },
});
const styles = {
  layout: {
    borderColor: grey[100],
    borderWidth: 1,
    borderStyle: "solid",
    padding: 2,
    boxShadow:
      "rgba(0, 0, 0, 0.04) 0px 4px 8px, rgba(0, 0, 0, 0.04) 0px 8px 16px -3px, rgba(102, 187, 106, 1) 0px 3px 0px inset",
    borderRadius: 2,
    transition: "all 0.1s ease-in-out",
    cursor: "pointer",
  },

  title: {
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 700,
    noWrap: true,
    textAlign: "left" as const,
    pb: 2,
  },
};

export const cardStyles = styles;
